<template>
  <div class="paymentRegistForm">
    <app-loading class="loading" :isLoading="isLoading"></app-loading>
    <template v-if="loadFinish">

      <!-- 前回の決済情報 -->
      <template v-if="display === 'last'">
        <h1 class="paymentRegistForm__title">お支払い情報を確認</h1>
        <div class="paymentRegistForm__comfirmation">
          <p class="paymentRegistForm__comfirmation__head">ご登録済みお支払い情報</p>
          <template v-if="subscInfo.payee === 'SBPS-credit'">
            <CardInfo
              class="paymentRegistForm__comfirmation__info"
              :card-number="card.number"
              :card-expiration="card.expiration"
            />
            <NextButton label="別のお支払い情報を登録する" class="paymentRegistForm__next" @clicked="anotherPayment"/>
            <SubscDescription :subsc-price="subscPrice" :is-subsc-trial="isSubscTrial || 1" />
            <BaseButton
              class="paymentRegistForm__button"
              :is-disabled="buttonIsDisabled || isLoading"
              label="サブスクリプションを再開する"
              @clicked="updateCardData"
            />
          </template>
          <template v-else-if="subscInfo.payee === 'AmazonPay'">
            <div class="paymentRegistForm__amazonpayInfo">
              <img src="/static/img/amazonpay.png" alt="Amazon Pay">
            </div>
            <NextButton label="別のお支払い情報を登録する" class="paymentRegistForm__next" style="padding:20px 0 30px;" @clicked="anotherPayment"/>
            <SubscDescription :subsc-price="subscPrice" :is-subsc-trial="isSubscTrial || 1" />
            <div class="paymentRegistForm__amazonpay">
              <amazon-pay-button :render='amazonPayArray' />
            </div>
          </template>
        </div>
      </template>

      <!-- 新規登録 -->
      <template v-else-if="display === 'new'">
        <p v-if="subscInfo.status === null" class="paymentRegistForm__step">ステップ2/2</p>
        <h1 class="paymentRegistForm__title">お支払い情報を登録</h1>
        <Attention v-if="updatePaymentError.error_message" :text="updatePaymentError.error_message"/>
        <!-- 支払い方法切替えのタブ -->
        <subsc-select-payment-method
          :select="selectPaymentMethod"
          @click="(value) => selectPaymentMethod = value"
        />
        <!-- 表示中のタブが、クレジットカードの場合 -->
        <transition>
          <div v-show="selectPaymentMethod === 'credit'">
            <div class="paymentRegistForm__form">
              <p class="town-card__img">
                <img width="160" src="https://websmart.zappallas.com/web_image?url=http%3A%2F%2Fwebpayment.smart-srv%2Fimage%3Fid%3D11315" alt="card">
              </p>
              <form-credit-card
                label="カード番号"
                name="cc_number"
                data-vv-name="cc_number"
                data-vv-value-path="formattedValue"
                placeholder="例）1234 5678 9123 1234"
                v-model="ccNumber"
                :validation="{ rules: {
                  required: true,
                  credit_card: true
                } }"
              />
              <form-credit-expire
                name=""
                label="カード有効期限"
                month-name="cc_expiration_m"
                year-name="cc_expiration_y"
                :validation="{ rules: {
                  required: true
                } }"
                v-model="ccExpiration"
              />
              <form-security-code v-model="securityCode" />
            </div>
            <SubscDescription :subsc-price="subscPrice" :is-subsc-trial="isSubscTrial || 1" />
            <BaseButton
              class="paymentRegistForm__button"
              :is-disabled="buttonIsDisabled || isLoading"
              label="サブスクリプションを再開する"
              @clicked="registCardData"
            />
          </div>
        </transition>
        <!-- 表示中のタブが、AmazonPay で、クレジットカード未登録 の場合 -->
        <transition>
          <div v-show="selectPaymentMethod === 'amazonpay'">
            <div class="paymentRegistForm__amazonpay">
              <amazon-pay-button :render='amazonPayArray' />
            </div>
          </div>
        </transition>
      </template>

    </template>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import * as type from '@/utvStore/store/mutation-types'
import Attention from './common/Attention'
import BaseButton from './common/BaseButton'
import NextButton from './common/NextButton'
import SubscDescription from './SubscDescription'
import CardInfo from './partials/CardInfo'
import AmazonPayButton from './Payment/AmazonPayButton'
import SubscSelectPaymentMethod from './SubscSelectPaymentMethod'

export default {
  name: 'SubscRejoin',
  components:{
    Attention,
    BaseButton,
    NextButton,
    SubscDescription,
    CardInfo,
    AmazonPayButton,
    SubscSelectPaymentMethod,
  },
  data() {
    return {
      // クレジットカード番号
      ccNumber: '',
      // クレカ 有効期限
      ccExpiration: '',
      // クレカ セキュリティーコード
      securityCode: '',
      updatePaymentError: {},
      isLoading: false,
      validateFlags: {},
      buttonIsDisabled: false,
      loadFinish: false,
      // 支払い方法の切り替え
      selectPaymentMethod: 'credit',
      // 表示する画面（前回の決済情報、新規で登録）last, new
      display: 'last',
    }
  },
  props: {
    merchantId: {
      type:String,
      default:''
    },
    serviceId: {
      type:String,
      default:''
    },
    action: {
      type:String,
      default:''
    },
    token: {
      type:String,
      default:''
    },
    subscPrice: {
      type: Number,
      default:0
    },
    // Amazon Pay ボタン生成データ
    amazonPayArray: {
      type: Object,
      default() {
        return {}
      }
    },
    // サブスクのお試し2週間無料が有効か
    isSubscTrial: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    ...mapState({
      accessToken: state => state.auth.accessToken,
      card: state => state.payment.card,
      userInfo: state => state.account.user,
      subscInfo: state => state.account.subscription
    }),
    ...mapGetters(['isLoggedIn']),
  },
  created() {
    this.isLoading = true
    this.subscInfo.payee
    if (this.isLoggedIn) this.getPaymentInfo()
    if (this.subscInfo.payee) {
      this.selectPaymentMethod = this.subscInfo.payee === 'AmazonPay' ? 'amazonpay' : 'credit'
    }
  },
  watch:{
    validateFlags: {
      handler(n,o) {
        this.buttonIsDisabled = Object.keys(n).some((key)=>{
          return n[key].invalid
        })
      },
      deep: true
    },
    isLoggedIn(isLogin){
      if(isLogin) this.getPaymentInfo()
    }
  },
  methods: {
    anotherPayment(){
      this.display = 'new'
      window.scrollTo(0, 0)
      this.$nextTick(() => {
        this.validateFlags = this.$validator.flags
      })
    },
    getPaymentInfo() {
      if (this.isLoggedIn && this.accessToken) {
        //カード情報取得
        this.$store.dispatch(type.GET_PAYMENT_INFO, { access_token: this.accessToken })
        .catch((err)=> console.log('card-unregistered!'))
        .finally(()=>{
          this.isLoading = false
          this.loadFinish = true
          this.$nextTick(() => {
            this.validateFlags = this.$validator.flags
          })
        })
      }
    },
    isValid() {
      if (!this.ccNumber || this.securityCode.length <= 2 || !this.ccExpiration.month || !this.ccExpiration.year || !!this.$validator.errors.items.length) {
        this.updatePaymentError = { error_message: '入力されていない項目があります。' }
        window.scrollTo(0, 0)
        this.isLoading = false
        return false
      }
      this.updatePaymentError = {}
      return true
    },
    // クレカ情報更新
    updateCardData() {
      this.isLoading = true
      window.scrollTo(0, 0)
      //カード登録済みの場合
      const data = {
        access_token: this.accessToken,
        token: '',
        tokenKey: '',
        user_id: this.userInfo.id
      }
      this.subscStart(data)
    },
    // クレカ情報登録
    registCardData() {
      if (!this.isValid()) return
      if (!window.com_sbps_system) throw new Error('Error: window.com_sbps_system がありません。')
      this.isLoading = true
      window.scrollTo(0, 0)
      const data = {
        merchantId: this.merchantId,
        serviceId: this.serviceId,
        ccNumber: this.ccNumber,
        ccExpiration: `20${this.ccExpiration.year}${
          this.ccExpiration.month
        }`,
        securityCode: this.securityCode
      }
      window.com_sbps_system.generateToken(data, this.afterGenerateToken)
    },
    afterGenerateToken(response) {
      if (response.result == 'OK') {
        this.updatePaymentError = {}
        const { tokenResponse } = response
        const data = {
          access_token: this.accessToken,
          token: tokenResponse.token,
          tokenKey: tokenResponse.tokenKey,
          user_id: this.userInfo.id
        }
        this.subscStart(data)
      } else {
        window.scrollTo(0, 0);
        this.updatePaymentError =  {
          error_message: '入力内容に誤りがあります。登録するクレジットカードをご確認の上、再度入力を行ってください。'
        }
        this.isLoading = false
      }
    },
    //サブスク開始
    subscStart(data){
      const api = type.UPDATE_PAYMENT_INFO_SUBSC_REJOIN
      const transition = '/'

      this.$store.dispatch(api, data).then(() => {
        window.location.href = transition
      })
      .catch((err)=>{
        window.scrollTo(0, 0);
        this.updatePaymentError =  {
          error_message:`${err.error_message} エラーコード:${err.error_code}`
        }
      })
      .finally(()=> this.isLoading = false)
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/commons/commonVariables.scss";
.paymentRegistForm{
  color: $col_base_black;
  padding: 38px 30px 40px;
  max-width: 580px;
  margin: auto;

  &__step{
    font-weight: bold;
    font-size: 11px;
    text-align: center;
    margin: 0;
    &::after {
      content: '';
      display: block;
      width: 15px;
      height: 2px;
      margin: 5px auto 0;
      background: linear-gradient(65.54deg, $col_temp_key1 21.4%, $col_temp_key2 76.64%);
    }
  }

  &__title{
    font-size: 21px;
    line-height: 31px;
    text-align: center;
    margin: 2px 0 40px;
  }

  &__button{
    margin: 30px 0;
  }

  &__comfirmation{
    margin: 0;
    &__head{
      font-size: 12px;
      background: linear-gradient(56.98deg, #FFF3F5 21.4%, #F9F4FD 76.64%);
      mix-blend-mode: multiply;
      line-height: 35px;
      padding: 0 30px;
      margin: 0 -30px;
    }
    &__info{
      padding: 15px 30px !important;
      margin: 0 -30px;
      border-bottom: solid 1px $col_temp_gray3;
    }
  }
  &__amazonpay {
    width: 74%;
    min-width: 233px;
    margin: 32px auto 0;
  }
  &__amazonpayInfo {
    margin: 0 -30px;
    padding: 23px 30px 18px;
    border-bottom: 1px solid #DCDFE2;
    img {
      width: 112px;
      max-width: 100%;
      vertical-align: bottom;
    }
  }
  &__next {
    padding: 20px 0 30px;
  }
}

.loading {
  position: absolute;
  z-index: 3;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.v-enter-active,
.v-leave-active {
  transition: all 200ms ease-out 0s;
}
.v-enter, .v-leave-to {
  opacity: 0;
}
.v-enter-to, .v-leave {
  opacity: 1;
}
</style>

<style lang="scss">
.paymentRegistForm .baseButton__button {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/SubscRejoin.vue